import { render, staticRenderFns } from "./ReturnTransferReservationForm.vue?vue&type=template&id=d4e2be94&scoped=true&"
import script from "./ReturnTransferReservationForm.vue?vue&type=script&lang=js&"
export * from "./ReturnTransferReservationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e2be94",
  null
  
)

export default component.exports